import React from 'react';

const approvalViewerLbl = 'LiL Gltf viewer';
// Approval viewer rendering in Iframe
const ApprovalViewer = ({ modelUrl }) => {
	const viewerUrl = process.env.REACT_APP_APPROVAL_VIEWER;
	return (
		<iframe
			title={approvalViewerLbl}
			// encoding the URL to make it work with approval viewer.
			src={`${viewerUrl}${escape(modelUrl)}`}
			scrolling="no"
			allowFullScreen
			data-cy="approval-viewer-iframe"
		/>
	);
};

export default ApprovalViewer;
